import { gql } from 'apollo-boost';

export const TRIAL_SCHOOLS = gql`
query invoiceRequests{
    invoiceRequests(isTrial: true) {
        id
        studentsCounter
        orderedAt
        contactPerson
        contactEmail
        school {
            id
            name
            studentsCounter
        }
    }
}
`;

export const TRIALS_CSV = gql`
query trialInvoicesList{
    trialInvoicesList
}`

export const TRIAL_SCHOOLS_LIST = gql`
query trialSchoolsList{
    trialSchoolsList{
                id
                subscribedSeats
                createdAt
                expiresAt
                school {
                      id
                      name
                      studentsCounter
                      billingProfile {
                        id
                        contactEmail
                        contactPerson
                    }
                } 
    }
}
`;